/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class SensitivityAnnotation {
  /**
  * The file path where the sensitivity annotation was found
  */
  'filePath': string;
  /**
  * The name of the sensitivity property
  */
  'propertyName': string;
  /**
  * The value of the sensitivity property
  */
  'propertyValue': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "filePath",
      "baseName": "filePath",
      "type": "string",
      "format": ""
    },
    {
      "name": "propertyName",
      "baseName": "propertyName",
      "type": "string",
      "format": ""
    },
    {
      "name": "propertyValue",
      "baseName": "propertyValue",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return SensitivityAnnotation.attributeTypeMap;
  }

  public constructor() {
  }
}

